export const UPDATE_CART = 'UPDATE_CART'
export const REMOVE_ITEM = 'REMOVE_ITEM'

export const LOADING_INIT = 'LOADING_INIT'
export const LOADING = 'LOADING'
export const RESET_LOADING = 'RESET_LOADING'
export const GET_RESTAURANT = 'GET_RESTAURANT'

export const REFRESH_DATA = 'REFRESH_DATA'
export const TIMER_SUCCESS = 'TIMER_SUCCESS'

export const SHOW_LOGIN = 'SHOW_LOGIN'
export const SET_LAST_ACTIVE = 'SET_LAST_ACTIVE'

export const AGREE_OVERTIME = 'AGREE_OVERTIME'
